import React, { Suspense } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import PrivateRoute from "./components/shared/PrivateRoute";
import { ToastProvider } from "./components/ui/Toast";

// Preloader (confere o token no servidor)
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));
const Home = React.lazy(() => import("./components/pages/Home"));
const Reports = React.lazy(() => import("./components/pages/Reports"));
const Receipts = React.lazy(() => import("./components/pages/Receipts"));
const Config = React.lazy(() => import("./components/pages/Config"));
const Defaultlogin = React.lazy(() => import("./components/pages/prebuilt-pages/Defaultlogin"));

function App() {
  return (
    <Router basename={"/"}>
      <ToastProvider>
        <Suspense fallback={<div className="c-boot" role="status" aria-label="Carregando" />}>
          <Preloader />
          <Switch>
            {/* Pública */}
            <Route exact path="/default-login" component={Defaultlogin} />

            {/* Autenticadas: sem sessão, o guard manda para o login */}
            <PrivateRoute exact path="/" component={Home} />
            <PrivateRoute exact path="/reports" component={Reports} />
            <PrivateRoute exact path="/receipts" component={Receipts} />
            <PrivateRoute exact path="/setup" component={Config} />

            {/* Qualquer outro endereço volta ao início (e, sem sessão, ao login) */}
            <Redirect to="/" />
          </Switch>
        </Suspense>
      </ToastProvider>
    </Router>
  );
}

export default App;
